<template>
    <zen-message-modal :isOpen="isOpen" title="Roll Back to This Version?">
        <div class="space-y-4">
            <p class="text-sm text-taupe-600">
                This publishes the value and rules from
                <span v-if="versionTimestamp" class="font-medium">
                    <zen-date-time :value="versionTimestamp" format="short" />
                </span>
                <span v-else>this version</span>
                immediately, replacing the currently live target.
            </p>

            <div
                v-if="error"
                class="rounded-lg bg-red-50 ring-1 ring-red-200 p-3"
            >
                <p class="text-sm font-medium text-red-800">{{ error }}</p>
            </div>

            <div>
                <label
                    for="rollback-comment"
                    class="block text-sm font-medium text-taupe-800"
                >
                    Comment
                    <span
                        v-if="commentsRequired"
                        class="text-red-500 font-normal italic"
                    >
                        (Required)
                    </span>
                </label>
                <div class="mt-1.5">
                    <textarea
                        :value="comment"
                        @input="$emit('update:comment', $event.target.value)"
                        id="rollback-comment"
                        name="comment"
                        rows="2"
                        class="block w-full rounded-md border-taupe-300 bg-white shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                    ></textarea>
                </div>
            </div>

            <div v-if="confirmationRequired">
                <label
                    for="rollback-confirmation"
                    class="block text-sm font-medium text-taupe-800"
                >
                    Confirmation
                    <span class="text-red-500 font-normal italic"
                        >(Required)</span
                    >
                </label>
                <p class="mt-0.5 text-xs text-taupe-500">
                    Type
                    <span class="font-mono font-medium">{{ flagKey }}</span>
                    to confirm.
                </p>
                <div class="mt-1.5">
                    <input
                        type="text"
                        :value="confirmation"
                        @input="
                            $emit('update:confirmation', $event.target.value)
                        "
                        id="rollback-confirmation"
                        name="confirmation"
                        :placeholder="flagKey"
                        class="block w-full rounded-md border-taupe-300 bg-white shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                    />
                </div>
            </div>
        </div>

        <template v-slot:buttons>
            <zen-button
                variant="primary"
                @click="$emit('confirm')"
                :disabled="!allowRollback || processing"
            >
                {{ processing ? 'Please wait' : 'Roll Back' }}
            </zen-button>
            <zen-button
                variant="secondary"
                @click="$emit('close')"
                :disabled="processing"
            >
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RollbackTargetModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        versionTimestamp: {
            type: String,
            default: null,
        },
        flagKey: {
            type: String,
            default: null,
        },
        commentsRequired: {
            type: Boolean,
            default: false,
        },
        confirmationRequired: {
            type: Boolean,
            default: false,
        },
        allowRollback: {
            type: Boolean,
            default: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
        comment: {
            type: String,
            default: null,
        },
        confirmation: {
            type: String,
            default: null,
        },
    },
    emits: ['close', 'confirm', 'update:comment', 'update:confirmation'],
}
</script>
